"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMELINE_TABLE_DATA_INDICES = void 0;
exports.TIMELINE_TABLE_DATA_INDICES = {
    CHANGE_TYPE: 'changeType',
    DISPLAY_NAME: 'displayName',
    LAST_MODIFIED_BY_NAME: 'lastModifiedByName',
    SONAR_OBJECT_TYPE: 'sonarObjectType'
};
//# sourceMappingURL=TIMELINE_TABLE_DATA_INDICES.js.map